import { clsx } from "clsx";
import type { CSSProperties, FC } from "react";

import { useVisuallyLoading } from "../../hooks.ts";
import style from "./LoadingBar.module.css";
import { LoadingBarIntent } from "./settings.ts";

export interface LoadingProps {
  /** Indeterminate. Fake a longer loading if it is updated too quickly */
  isLoading?: boolean;
  debounceStart?: number;
  minimumTimeout?: number;
  /** From 0 to 100% */
  progress?: number;
  intent?: LoadingBarIntent;
  style?: CSSProperties;
  className?: string;
  topPosition?: boolean;
}

export const LoadingBar: FC<LoadingProps> = (props) => {
  // Fake loading for at least 1000ms
  const isVisuallyLoading = useVisuallyLoading(props.isLoading ?? false, props.debounceStart, props.minimumTimeout);

  if (!isVisuallyLoading && props.progress == null) return null;

  return (
    <div
      className={clsx(style.progress_bar, props.className, { [style.absolute_top]: props.topPosition })}
      style={props.style}
      role={"progressbar"}
      aria-valuenow={props.progress ?? 100}
      aria-label={"Loading..."}
      data-testid={"loading-bar"}
    >
      <div
        className={clsx(style.progress_track, {
          [style.success]: props.intent === LoadingBarIntent.Success,
          [style.warning]: props.intent === LoadingBarIntent.Warning,
          [style.error]: props.intent === LoadingBarIntent.Error,
        })}
        style={{ width: props.progress != null ? `${props.progress}%` : undefined }}
      >
        {!!isVisuallyLoading && <div className={style.progress_load} />}
      </div>
    </div>
  );
};
